export default "__VITE_ASSET__41bb70be__"